module.exports = __webpack_public_path__ + "static/media/signup.a5f7bfb0.png";